import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealTiersEntity } from '../../domain/entities/MealTiersEntity'
import type { MealTierAdminDto } from '@/backend/market'

export class MealTiersModel extends MealTiersEntity {
  constructor(dataDto: MealTierAdminDto) {
    super()
    mapEntityProperties<MealTiersEntity>(this, dataDto)
  }
}